// extracted by mini-css-extract-plugin
export default {"globalNav":"global-nav__globalNav___+yhMdmCy","navMenu":"global-nav__navMenu___a+E0Uv9X","navMobileControls":"global-nav__navMobileControls___orZyp779"};